import Button from 'components/ui/button';
import Card from 'components/ui/card';

/** Falha de qualquer leitura, sem coleção parcial (SEL-11). */
export default function ErroDaColecao({ onTentarDeNovo }: { onTentarDeNovo: () => void }) {
  return (
    <Card role="alert" padded={false} className="flex flex-wrap items-center justify-between gap-4 px-6 py-5">
      <p className="m-0 text-sm text-content">Não foi possível carregar os seus selos.</p>
      <Button variant="solido" size="sm" onClick={onTentarDeNovo}>
        Tentar de novo
      </Button>
    </Card>
  );
}
